const UserManagement = {
  getUsers: {
    url: "/user",
    method: "GET",
  },
  getSingleUser: (id) => ({
    url: `/user/${id}`,
    method: "GET",
  }),
  updateUserStatus: (id) => ({
    url: `/user/${id}`,
    method: "PATCH",
  }),
  editUserDetails: (id) => ({
    url: `admin/edit-user/${id}`,
    method: "PUT",
  }),
  getMemorialDetailsByUser: (id) => ({
    url: `user/${id}`,
    method: "GET",
  }),
};
export default UserManagement;
